import Vue from 'vue';

export default Vue.extend({
   props: {
      api: {
         type: String,
         required: false,
         default: 'dataService'
      },
      obj: {
         type: String,
         required: false
      },
      filterBy: {
         type: Array,
         required: false
      }
   },

   data() {
      return {
         title: '',
         permissions: [],
         mainHeight: 500
      }
   },

   watch: {
      '$store.state.company.selectedStore': function (newVal) {
         if (this.hasStoreFilter) {
            this.setPageFilter('storeId', newVal, this.$store.state.company.selectedStoreName);
         }

      },

      '$store.getters.activePageFilters': function (filters) {
         if (this.pageFiltersChange) this.pageFiltersChange(filters);
      },

      filterBy: {
         immediate: true,
         handler: function (filters) {
            // console.log(filters);
            setTimeout(() => this.$store.dispatch('updateAllPageFilters', filters), 100);
         }
      }
   },

   methods: {
      log (...args) {
         console.log(this.obj + ' - ', ...args);
      },

      resized() {
         let wH = window.innerHeight;
         let elements = document.getElementsByClassName('app--toolbar');
         let tH = (elements && elements.length) ? elements[0].clientHeight : 0;

         this.mainHeight = wH - tH;

         // console.log(this.mainHeight);
      },

      createPageFilters(filters) {
         this.$store.dispatch('createPageFilters', {filters});
         // console.log('filters created');
      },

      setPageFilter(field, value, label) {
         this.$store.dispatch('updatePageFilter', {field, value, label});
      }

   },

   computed: {
      hasPageFilters() {
         return this.$store.getters.hasFilters;
      },

      pageFilters() {
         return this.$store.getters.activePageFilters;
      },

      pageFilterLabels() {
         return this.$store.getters.pageFilterLabels;
      },

      hasStoreFilter() {
         return this.$store.getters.hasStoreFilter;
      },

      userPermissions() {
         return this.$store.state.company.permissions;
      }

   },

   created() {
      this.resized();
   },

   mounted() {
      window.getApp.$on('APP_MAIN_CONTENT_RESIZE', this.resized);
   },

   beforeDestroy() {
      window.getApp.$off('APP_MAIN_CONTENT_RESIZE', this.resized);
   }

})



//////////////////
// WEBPACK FOOTER
// ./node_modules/@consigmais-team/vue-common/layout/defaultPage/pageClass.js
// module id = XUg9
// module chunks = 0